import { ServiceCode } from '../enums/serviceCode';

export const servicesWithDisabledRequestPdf = [ServiceCode.OSASQ];
